import React,{useEffect, useState} from 'react'
import '../common.scss';
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts'
import HighchartsHeatmap from "highcharts/modules/heatmap";
import { isJson } from '../../../utils/converter';
import axios from 'axios';
import urls from '../../../utils/url';
import moment from 'moment';
import Cookie from 'js-cookie';
import PatternFill from 'highcharts/modules/pattern-fill';
import HighchartsAnnotations from 'highcharts/modules/annotations';

HighchartsAnnotations(Highcharts);
PatternFill(Highcharts);
HighchartsHeatmap(Highcharts);

Highcharts.SVGRenderer.prototype.symbols.x = function (x, y, w, h) {
  return [
      'M', x, y,
      'L', x + w, y + h,
      'M', x + w, y,
      'L', x, y + h
  ];
};

const IntrapartumGraph = (props) => {

  const cookie = Cookie.get('access_token')
  const {patientID} = props;
  
  const [active, setActive] = useState(0)
  const [loading, setLoading] = useState(false)
  const [intrapartumData, setIntrapartumData] = useState([])
  const [firstCervixTime, setFirstCervixTime] = useState(0)
  const [firstCervixValue, setFirstCervixValue] = useState('')
  const [firstReadingTime, setFirstReadingTime] = useState(0)
  const [plotPartograph, setPlotPartograph] = useState(false)
  const [tickPositions, setTickPositions] = useState([])
  const [hourTickPostions, setHourTickPostions] = useState([])
  const [fhr, setFhr] = useState([])
  const [contraction, setContraction] = useState({})
  const [amniotic, setAmniotic] = useState({})
  const [headDescent, setHeadDescent] = useState([])
  const [cervix, setCervix] = useState([])
  const [alerts, setAlerts] = useState([])
  const [actions, setActions] = useState([])
  const [oxytocin, setOxytocin] = useState([])
  const [drugs, setDrugs] = useState([])
  const [systolic, setSystolic] = useState([])
  const [diastolic, setDiastolic] = useState([])
  const [pulse, setPulse] = useState([])
  const [temperature, setTemperature] = useState([])
  const [firstCervixDiameter, setFirstCervixDiameter] = useState('');
  const [isDataAvailable, setDataAvailable] = useState(false);
  const [amnioticGraphData, setAmnioticGraphData] = useState();
  const [oxytocinGraphData, setOxytocinGraphData] = useState();
  const [tempratureGraphData, setTempratureGraphData] = useState();
  const [drugsGraphData, setDrugsGraphData] = useState();
  const [contractionGraphData, setContractionGraphData] = useState();
  const [contractionLine, setContractionLine] = useState([]);
  const [mouldng, setMoulding] = useState();

  let amniotic_data = [];
  let moulding_data = []
  let contraction_duration = {};
  const contractions_data = [
    {
      name: '< 20 seconds',
      data: [], 
      grouping: false,
      pointPadding: 0.2,
      color: {
        pattern: {
          path: {
            d: 'M 1 1 A 0.5 0.5 0 1 0 1.1 1', 
            stroke: '#000',
            strokeWidth: 0.8,
            fill: '#000'
          },
          width: 4,
          height: 4,
          backgroundColor: '#fff'
        }
      }
    },
    {
      name: '20–40 seconds',
      data: [],
      grouping: false,
      pointPadding: 0.2,
      color: {
        pattern: {
          path: {
            d: 'M 0 0 L 6 6 ',
            stroke: '#000',
            strokeWidth: 1.5
          },
          width: 6,
          height: 6,
          backgroundColor: '#fff'
        }
      }
    },
    {
      name: '> 40 seconds',
      grouping: false,
      pointPadding: 0.2,
      data: [],
      color: '#000'
    }
  ];

  let contractions_intensity = {};
  let oxytocin_data = []
  let drugs_data = [];
  let temperature_data = []
  
  // Not used anymore - Intensity is not to be looked for.
  // var intensity_labels = ['', 'Mild', 'Moderate', 'Strong'];
  let intensity_labels = [];

  useEffect(() => {
    axios.get(`${urls. BETA_URL}v1/nurse/patients/?patient_ids=${patientID}&forms=labor_data,basic_detail`,
      {
        headers: {
        'Request-ID': 'allow|me', 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${cookie}`
      }
      }).then((res) => {
        if(res.data){
          const json_data = isJson(res.data)
          const response = json_data.response[0].labor_data
          const basic_detaiil = json_data.response[0].basic_detail;
          const new_data = response.map(obj => ({...obj, data_time: obj.data_time *= 1000 }))
          const sorted_data = new_data.sort((a, b) => (a.data_time > b.data_time) ? 1 : -1);

          setIntrapartumData(sorted_data)
          sorted_data.filter(obj => {
            if (obj.data_type === 'cervix_diameter' && parseInt(obj.param_1) >= 4 && firstCervixTime == 0){
              setPlotPartograph(true)
            }
          })
          setLoading(false) ;
        }
      }).catch((err) => {
        console.log("Error in Fetching Data",err)
        setLoading(false)
      }
    )
  },[])

  useEffect(() => {
  const fetchData = async () => {
    Highcharts.setOptions({
      time: {
        useUTC: false
      },
      chart: {
        style: {
          fontFamily: 'Poppins, sans-serif'
        }
      }
    });

    if (plotPartograph) {
      // Anchor (axis start) comes from the first reading >= 4 cm; the series itself keeps every reading
      // so earlier points fall off the left edge and the line enters from it.
      const cervix_data = intrapartumData.filter(obj => obj.data_type === "cervix_diameter" && parseFloat(obj.param_1) >= 4);
      const all_cervix = intrapartumData.filter(obj => obj.data_type === "cervix_diameter" && !isNaN(parseFloat(obj.param_1)));
      setCervix(all_cervix.map(obj => [parseInt(moment(obj.data_time).format('x')), parseFloat(obj.param_1)]));

      const [first_cervix_time, first_cervix_value] = [parseInt(moment(cervix_data[0].data_time).format('x')), cervix_data[0].param_1];

      if (firstCervixTime == 0) {
        setFirstReadingTime(first_cervix_time);
        setFirstCervixValue(parseInt(first_cervix_value));
      } else {
        const first_timestamp = first_cervix_time - ((parseInt(first_cervix_value) - 5) * 3600 * 1000);
        setFirstReadingTime(first_timestamp);
        setFirstCervixValue(parseInt(first_cervix_value));
      }

      // Axis starts when the alert line is at 3 cm (1 cm/hr), so a 4 cm first reading lands at hour 1
      const offsetHours = first_cervix_value - 3;
      const first_timestamp = first_cervix_time - (offsetHours * 3600 * 1000);

      const tickPos = getTickPositions(first_timestamp);
      const hourTicks = getHourTickPositions(first_timestamp);
      setTickPositions(tickPos);
      setHourTickPostions(hourTicks);

      // Alert/Action guide lines, measured from the reference partograph:
      // Alert runs 4 -> 10 cm over ALERT_SPAN_HOURS starting at the 4 cm reading time (slightly flatter than 1 cm/hr,
      // so it separates from the cervix line); Action is the same line, starting at 4 cm, shifted by ACTION_SHIFT_HOURS.
      const ALERT_SPAN_HOURS = 6.5;
      const ACTION_SHIFT_HOURS = 4.35;
      const alert_start = first_cervix_time - ((parseFloat(first_cervix_value) - 4) * 3600 * 1000);
      let alert = [], action = [];
      const steps = ALERT_SPAN_HOURS * 2;
      for (let j = 0; j <= steps; j++) {
        const baseY = 4 + j * (6 / steps);
        const alert_time = alert_start + j * 1800 * 1000;
        const action_time = alert_time + ACTION_SHIFT_HOURS * 3600 * 1000;
        alert.push([alert_time, baseY]);
        action.push([action_time, baseY]);
      }
      setAlerts(alert);
      setActions(action);

      const fhr_data = intrapartumData.filter(obj => obj.data_type === "fetal_heart_rate");
      const fhr = fhr_data.map(obj => [parseInt(moment(obj.data_time).format('x')), parseFloat(obj.param_1)]);
      setFhr(fhr);

      const amniotic_fluid_data = intrapartumData.filter(obj => obj.data_type === "amniotic_fluid" && parseInt(obj.data_time) >= first_cervix_time);
      const temp_amniotic_fluid = {};
      amniotic_fluid_data.forEach(obj => {
        const time = parseInt(moment(obj.data_time).format('x'));
        for (let i = 1; i < tickPos.length; i++) {
          if (tickPos[i - 1] <= time && time < tickPos[i]) {
            temp_amniotic_fluid[tickPos[i - 1].toString()] = obj.param_1;
          }
        }
      });
      setAmniotic(temp_amniotic_fluid);

      const head_descent_data = intrapartumData.filter(obj => obj.data_type === "head_descent");
      const head_descent = head_descent_data.map(obj => [parseInt(moment(obj.data_time).format('x')), parseFloat(obj.param_1)]);
      setHeadDescent(head_descent);

      const bp_data = intrapartumData.filter(obj => obj.data_type === "bp");
      setSystolic(bp_data.map(obj => [parseInt(moment(obj.data_time).format('x')), parseFloat(obj.param_1)]));
      setDiastolic(bp_data.map(obj => [parseInt(moment(obj.data_time).format('x')), parseFloat(obj.param_2)]));

      const pulse_data = intrapartumData.filter(obj => obj.data_type === "pulse");
      setPulse(pulse_data.map(obj => [parseInt(moment(obj.data_time).format('x')), parseFloat(obj.param_1)]));

      // Debug: compare plotted coordinates against the API data
      const debugRows = [];
      const addDebug = (type, rows, yIdx) => rows.forEach(obj => {
        const x = parseInt(moment(obj.data_time).format('x'));
        debugRows.push({ data_type: type, data_time: obj.data_time / 1000, elapsedHours: +((x - first_timestamp) / 3600000).toFixed(2), x, y: parseFloat(obj[yIdx]) });
      });
      addDebug('cervix_diameter', all_cervix, 'param_1');
      addDebug('fetal_heart_rate', fhr_data, 'param_1');
      addDebug('head_descent', head_descent_data, 'param_1');
      addDebug('bp_systolic', bp_data, 'param_1');
      addDebug('bp_diastolic', bp_data, 'param_2');
      addDebug('pulse', pulse_data, 'param_1');
      console.table(debugRows);

      const contraction_data = intrapartumData.filter(obj => obj.data_type === "contraction" && parseInt(obj.data_time) >= first_cervix_time);
      // Line graph uses every reading at its real timestamp (earlier ones fall off the left edge)
      setContractionLine(intrapartumData
        .filter(obj => obj.data_type === "contraction")
        .map(obj => [parseInt(moment(obj.data_time).format('x')), parseFloat(obj.param_1)]));
      const temp_contractions = {};
     // console.log('change interval to i')
      contraction_data.forEach(obj => {
        //console.log('inside contraction each data', obj)
        const time = moment(obj.data_time).format('x');
        for(let i = 1 ; i < tickPos.length ; i++){
            if(tickPos[i-1] <= parseInt(time) && parseInt(time) < tickPos[i]){
                temp_contractions[tickPos[i-1]] = {
                    'number' : parseInt(obj.param_1),
                    'duration': getContractionDurationStep(parseInt(obj.param_2)),
                    'intensity': 2, // 23 Oct 2018 - parseInt(value.param_3) -- Hardcoded for now. Not used anymore, seems to be outdated
                };
            }
        }
      })
      setContraction(temp_contractions);

      const oxytocin_data = intrapartumData.filter(obj => obj.data_type === "oxytocin" && parseInt(obj.data_time) >= first_cervix_time);
      //console.log(oxytocin_data, 'oxytin')
      const temp_oxytocin = {};
      oxytocin_data.forEach(value => {
        const time = parseInt(moment(value.data_time).format('x'));
        for (let i = 1; i < tickPos.length; i++) {
          if (tickPos[i - 1] <= time && time < tickPos[i]) {
            temp_oxytocin[tickPos[i - 1]] = {
              conc: value.param_1,
              drops: value.param_2
            };
          }
        }
      });
      setOxytocin(temp_oxytocin);

      const moulding = intrapartumData.filter(obj => obj.data_type === "moulding" && parseInt(obj.data_time) >= first_cervix_time);
      const temp_moulding = {};
      moulding.forEach(value => {
        const time = parseInt(moment(value.data_time).format('x'));
        for (let i = 1; i < tickPos.length; i++) {
          if (tickPos[i - 1] <= time && time < tickPos[i]) {
            temp_moulding[tickPos[i - 1]] = value.param_1;
          }
        }
      });
      setMoulding(temp_moulding)

      const temperature_data = intrapartumData.filter(obj => obj.data_type === "temperature" && parseInt(obj.data_time) >= first_cervix_time);
      const temp_temperature = [];
      temperature_data.forEach(value => {
        const time = parseInt(moment(value.data_time).format('x'));
        for (let i = 1; i < tickPos.length; i++) {
          if (tickPos[i - 1] <= time && time < tickPos[i]) {
            temp_temperature[tickPos[i - 1]] = value.param_1;
          }
        }
      });
      setTemperature(temp_temperature);

      const drugs_data = intrapartumData.filter(obj => obj.data_type === "drugs" && parseInt(obj.data_time) >= first_cervix_time);
      const temp_drugs = {};
      drugs_data.forEach(value => {
        const time = parseInt(moment(value.data_time).format('x'));
        for (let i = 1; i < tickPos.length; i++) {
          if (tickPos[i - 1] <= time && time < tickPos[i]) {
            temp_drugs[tickPos[i -1]] = `${value.param_1}<br/>(${value.param_2})<br/>${value.param_3}`;
          }
        }
      });
      setDrugs(temp_drugs);


      const result = buildChartSeries(temp_amniotic_fluid, tickPos, temp_contractions, temp_temperature, temp_oxytocin, temp_drugs, temp_moulding);
      if (result) {
        setDataAvailable(true);
      }

      const bishop_score = intrapartumData.filter(obj => obj.data_type === "bishop_score" && parseInt(obj.data_time) >= first_cervix_time);
      const placenta = intrapartumData.filter(obj => obj.data_type === "Placenta_Complication" && parseInt(obj.data_time) >= first_cervix_time);
      const complication_data = intrapartumData.filter(obj => obj.data_type === "TEMPERATURE_Postpartum_child_complication" && parseInt(obj.data_time) >= first_cervix_time);
    }
  };

  fetchData();
}, [intrapartumData, plotPartograph]);


  function getTickPositions(data_time){
    var positions = [];
    for(var i = 0; i < 25; i++){
        positions.push(data_time + (i*1800*1000));
    }
    return positions;
  }

  function getHourTickPositions(data_time){
    var positions = [];
    for(var i = 0; i < 13; i++){
        positions.push(data_time + (i*3600*1000));
    }
    return positions;
  }

  function getStep(){
    var width = window.screen.width;
    var step = 2 + parseInt((1280 - width)/150);
    if(step < 2){
        step = 2;
    }
    return step;
  }

  function tooltipFormat(val){
    if (val.y == '') {
        return Highcharts.dateFormat('%d %b %Y %I:%M:%S %p', val.x) + '<br/>' +
                        '<b>' + val.series.name + '</b>';
    }
    return Highcharts.dateFormat('%d %b %Y %I:%M:%S %p', val.x) + '<br/>' +
                        '<b>' + val.series.name + ': ' + val.y + '</b>';
  }

  function heatMapTooltipFormat(val) {
    const capitalizedValue = val.point.value
      ?.toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  
    return Highcharts.dateFormat('%d %b %Y %I:%M:%S %p', val.point.x) + '<br/>' +
           '<b>' + val.series.name + ': ' + capitalizedValue + '</b>';
  }
  
  function heatMapTooltipFormatTwoValue(ctx) {
    const point = ctx.point;
    const time = Highcharts.dateFormat('%d %b %Y %I:%M:%S %p', point.x);
    
    // Customize based on y-index
    if (point.y === 1) {
      return `
        <div>
          ${time}<br/>
          Oxytin: ${point.value}<br/>
        </div>`;
    } else if (point.y === 0) {
      return `
        <div>
          ${time}<br/>
          Drops: ${point.value}
        </div>`;
    }
  
    return false;
  }

  function heatMapTooltipFormatForAmniotic(ctx) {
    const point = ctx.point;
    const time = Highcharts.dateFormat('%d %b %Y %I:%M:%S %p', point.x);
  
    if (point.y === 1) {
      return `
        <div>
          ${time}<br/>
          Amniotic Fluid: ${point.value}
        </div>`;
    } else if (point.y === 0) {
      return `
        <div>
          ${time}<br/>
          Moulding: ${point.value}
        </div>`;
    }
  
    return false;
  }
  
  
  function getTextCoords(chart) {
    const texts = ['Alert', 'Action'];
    const names = ['Alert', 'Action'];
    const final_response = [];
  
    for (let i = 0; i < 2; i++) {
      const series = chart.series.find(s => s.name === names[i]);
      if (!series || !series.data || series.data.length < 2) continue;
  
      // Label sits centred on the middle of the line, just above it, rotated to the line's slope
      const point1 = series.data[0];
      const point2 = series.data[series.data.length - 1];
      if (!point1 || !point2 || point1.plotX == null || point2.plotX == null) continue;

      const dx = point2.plotX - point1.plotX;
      const dy = point2.plotY - point1.plotY;
      const angle = Math.atan2(dy, dx);
      const slope_deg = angle * 180 / Math.PI;

      const width = window.innerWidth;
      const fontSize = 6 + (12 / 1280) * width;

      // Normal pointing to the upper side of the line, so the text doesn't get struck through by it
      const gap = 18;
      const midX = (point1.plotX + point2.plotX) / 2 + chart.plotLeft + Math.sin(angle) * gap;
      const midY = (point1.plotY + point2.plotY) / 2 + chart.plotTop - Math.cos(angle) * gap;

      final_response.push({
        x: midX,
        y: midY,
        fontSize: fontSize + 'px',
        slope_deg,
        text: texts[i]
      });
    }
  
    return final_response;
  }
  
  
  function getContractionDurationStep(param2) {
    var step = parseInt(param2);
    if (step > 3) {
        step = 3;
    }
    return step;
  }

  const buildChartSeries = (temp_amniotic, tickPositions, temp_contractions, temp_temperature, temp_oxytocin, temp_drugs, temp_moulding) => {

    for(let intervals = 1 ; intervals < tickPositions.length ; intervals++){
      let label_pos = tickPositions[intervals - 1];

      //AMNIOTIC
      if(typeof(temp_amniotic[tickPositions[intervals-1]]) === 'undefined'){
          temp_amniotic[tickPositions[intervals-1]] = '';
      }
      if(typeof(temp_moulding[tickPositions[intervals-1]]) === 'undefined'){
        temp_moulding[tickPositions[intervals-1]] = '';
      }
      amniotic_data.push([label_pos, 1, temp_amniotic[tickPositions[intervals-1]]]);
      amniotic_data.push([label_pos, 0, temp_moulding[tickPositions[intervals-1]]]);

      //CONTRACTION
      if(typeof(temp_contractions[tickPositions[intervals-1]]) === 'undefined'){
        contractions_data[0]['data'].push([label_pos, 0]);
        contractions_data[1]['data'].push([label_pos, 0]);
        contractions_data[2]['data'].push([label_pos, 0]);
      } else {
          var curr_tick = tickPositions[intervals-1];
          var duration = temp_contractions[curr_tick]['duration'];
          if (duration > 0){
              contractions_data[duration-1]['data'].push([label_pos, temp_contractions[curr_tick]['number']]);
              contractions_data[duration%3]['data'].push([label_pos, 0]);
              contractions_data[(duration + 1)%3]['data'].push([label_pos, 0]);

              //Preparing data labels for mild, moderate and strong
              if(typeof(intensity_labels[temp_contractions[curr_tick]['intensity']]) !== 'undefined'){
                  contractions_intensity[curr_tick] = intensity_labels[temp_contractions[curr_tick]['intensity']];
              } else {
                  contractions_intensity[curr_tick] = '';
              }
          }
      }

      //OXYTOCIN
      if(typeof(temp_oxytocin[tickPositions[intervals-1]]) === 'undefined'){
        temp_oxytocin[tickPositions[intervals-1]] = {'conc' : '',  'drops' : ''};
      }

      oxytocin_data.push([label_pos, 1, temp_oxytocin[tickPositions[intervals-1]]['conc']]);
      oxytocin_data.push([label_pos, 0, temp_oxytocin[tickPositions[intervals-1]]['drops']]);

      //DRUGS
      if(typeof(temp_drugs[tickPositions[intervals-1]]) === undefined){
          temp_drugs[tickPositions[intervals-1]] = null;
      }
      drugs_data.push([label_pos, 0, temp_drugs[tickPositions[intervals-1]]]);

     //TEMPRATURE
      let tempValue = temp_temperature[tickPositions[intervals - 1]];

      if (typeof tempValue === 'undefined' || tempValue === null) {
        tempValue = null;
      } else {
        const numericVal = parseFloat(tempValue);
        if (numericVal >= 35 && numericVal <= 42) {
          tempValue = `${numericVal}°C`;
        } else if (numericVal >= 95 && numericVal <= 107) {
          tempValue = `${numericVal}°F`;
        } else {
          tempValue = `${numericVal}`; // or set to null if you want to hide
        }
      }
      temperature_data.push([label_pos, 0, tempValue]);
    }

    setAmnioticGraphData(amniotic_data);
    setContractionGraphData(contractions_data);
    setOxytocinGraphData(oxytocin_data)
    setTempratureGraphData(temperature_data)
    setDrugsGraphData(drugs_data)

    return true;
  }

  var chartMargin = 70;
  var legendFont = 10;
  var markerRadius = 8;
  var lineWidth = 3;
  var alertWidth = 2;
  var itemMargin = 2;

  const fetalGraph = {
      chart: {
          //marginLeft: chartMargin,
          marginLeft: 120,
          marginRight: 50, 
          height: 400,
      },
      title: {
          text: '',
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%e %b',
              week: '%e %b',
              month: '%b \'%y',
              year: '%Y'
          },
          min: tickPositions[0],
          max: tickPositions.slice(-1).pop(),
          tickPositions: hourTickPostions,
          labels: {
            formatter: function () {
              const tickTime = this.value;
              if (tickTime < firstReadingTime) {
                return '';
              }
              return Highcharts.dateFormat('%I:%M %p', tickTime);
            },
            step: getStep(),
          },
          title: {
              text: ''
          },
          gridLineColor:'#000000',
          gridLineWidth: 1,
      },
      yAxis: {
          title: {
              text: 'Fetal Heart Rate'
          },
          tickInterval: 1,
          gridLineColor: '#000000',
          gridLineWidth: 1,
          min: 80,
          max: 200,
          plotLines: [
              {
                  color: '#000000',
                  width: 3,
                  value: 110
              },
              {
                  color: '#000000',
                  width: 3,
                  value: 160
              },
          ],
          tickPositioner: function () {
              var positions = [],
              i = 80;
              while(i <= 200){
                  positions.push(i);
                  i+=10;
              }
              return positions;
          }
      },
      tooltip: {
          hideDelay: 0,
          shared: false,
          followPointer: false,
          zIndex: 10, 
          valueSuffix: '',
          formatter: function(){
              var val = this;
              return tooltipFormat(val);
          }
      },
      plotOptions: {
        series: {
          stickyTracking: false, // disables tooltip tracking near the point
          states: {
            hover: {
              enabled: true
            }
          }
        }
      },
      series: [
          {
            name: 'Fetal Heart Rate',
            data: fhr,
            lineWidth: lineWidth,
            marker:{
                radius : 4,
                symbol: "circle"
            },
            color: '#000'
          }
      ]
  }

  const amnioticGraph = {
    chart: {
      type: 'heatmap',
      marginLeft: 120,
      marginRight: 50,
      height: 150,
    },
    title: { 
      text: '' 
    },
    credits: { 
      enabled: false 
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        hour: '%I:%M %p'
      },
      min: tickPositions[0],
      max: tickPositions[tickPositions.length - 1],
      tickPositions: hourTickPostions,
      labels: {
        formatter: function () {
          return this.value < firstReadingTime ? '' : Highcharts.dateFormat('%I:%M %p', this.value);
        },
        step: getStep(),
      },
      title: { 
        text: '' 
      },
      gridLineColor: '#000000',
      gridLineWidth: 1,
      lineColor: '#000000',
      tickColor: '#000000'
    },
  
    yAxis: {
      categories: ['Moulding', 'Amniotic Fluid'],
      title: null,
      gridLineColor: '#000000',
      gridLineWidth: 1,
      lineColor: '#000000',
      tickColor: '#000000'
    },
  
    tooltip: {
      hideDelay: 0,
      shared: false,
      followPointer: false,
      useHTML: true,
      backgroundColor: '#ffffff',
      borderColor: '#ccc',
      formatter: function () {
        const point = this.point;
        // Show tooltip ONLY if value exists
        if (point && typeof point.value !== 'undefined' && point.value !== null &&  point.value !== '') {
          return heatMapTooltipFormatForAmniotic(this);
        }

        return false; // prevent tooltip from showing on null/empty
      },
      style: {
        width: `100%`,
        color: '#000000',
        fontSize: '10px',
      }
    },
    legend: { 
      enabled: false 
    },
    colorAxis: {
      stops: [
        [0, 'green'],
        [0.5, 'orange'],
        [0.9, 'red']
      ],
      min: -20
    },
    series: [{
      borderWidth: 0.5,
      borderColor: '#000000',
      data: amnioticGraphData,
      name: 'Amniotic Fluid',
      dataLabels: {
        enabled: true,
        x:25,
        format: '{point.value}',
        style: {
           color: '#000000' 
        }
      }
    }]
  };
  
  var series_data = [
    {
      name: 'Cervix Diameter (cm)',
      data: cervix,
      lineWidth: 2,
      marker: {
        radius: 6,
        symbol: 'x',
        lineWidth: 2,
        lineColor: 'black',
        fillColor: 'transparent', 
        states: {
          hover: {
            enabled: false 
          }
        }
      },
      color: '#000'
    }
  ];

  if(alerts.length > 0){
    series_data.push({
        name: 'Alert',
        data: alerts,
        showInLegend: false,
        enableMouseTracking: false,
        marker: {
            enabled: false
        },
        width: alertWidth,
        color: '#000'
    });
    series_data.push({
        name: 'Action',
        data: actions,
        showInLegend: false,
        enableMouseTracking: false,
        marker: {
            enabled: false
        },
        width: alertWidth,
        color: '#000'
    });
  }

  const cervixAndHeadDescentGraph = {
    title: {
      text: '',
    },
    credits: {
      enabled: false
    },
    chart: {
      marginLeft: 120,
      marginRight: 50,
      height:500,
        events: {
            redraw: function () {
              const chart = this;
              const renderer = chart.renderer;

              // ==== Cleanup Alert/Action text ====
              if (chart.alertActionTexts) {
                chart.alertActionTexts.forEach(el => el.destroy());
              }
              chart.alertActionTexts = [];

              if (alerts.length > 0) {
                const coords = getTextCoords(chart);
              
                coords.forEach((value, ind) => {
                  const textEl = renderer.text(value['text'], value['x'], value['y'])
                    .attr({
                      rotation: value['slope_deg'],
                      align: 'center',
                      zIndex: 10, // ensures it's on top
                      id: value['text'] + '_text'
                    })
                    .css({
                      color: '#222222',
                      fontSize: value['fontSize'],
                      fontWeight: 'normal'
                    });
              
                  // Add to chart renderer *and* export group if exists
                  if (chart.exportSVGElements) {
                    chart.exportSVGElements.push(textEl.add(chart.renderer.box));
                  } else {
                    textEl.add();
                  }
              
                  chart.alertActionTexts.push(textEl);
                });
              }
          
              // Cervix & Descent Custom Drawing Logic
              const leftOffset = chart.plotLeft - 110;
              const topCervix = chart.plotTop ;
              const bottomCervix = chart.plotTop + chart.plotHeight;
          
              if (chart.customLabels) {
                chart.customLabels.forEach(el => el.destroy());
              }
              chart.customLabels = [];
          
              // Cervix (Plot X)
              chart.customLabels.push(
                renderer.path(['M', leftOffset, topCervix, 'L', leftOffset, bottomCervix])
                  .attr({ 'stroke-width': 2, stroke: '#000000' }).add(),
                renderer.path(['M', leftOffset - 10, topCervix, 'L', leftOffset + 10, topCervix])
                  .attr({ 'stroke-width': 2, stroke: '#000000' }).add(),
                renderer.path(['M', leftOffset - 10, bottomCervix, 'L', leftOffset + 10, bottomCervix])
                  .attr({ 'stroke-width': 2, stroke: '#000000' }).add(),
                renderer.text('Cervix (cm)', leftOffset + 15, (topCervix + bottomCervix) / 2 - 40)
                  .css({ fontSize: '12px', fontWeight: 'bold' }).add(),
                renderer.text('(Plot X)', leftOffset + 25, (topCervix + bottomCervix) / 2 - 30)
                  .css({ fontSize: '10px' }).add()
              );
            },
             beforePrint: function () {
                this.printMode = true;
                this.redraw(); // trigger re-render with current layout
              },
            
              afterPrint: function () {
                this.printMode = false;
                this.redraw(); // restore post-print layout if needed
              }

        }
    },
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            millisecond: '%H:%M:%S.%L',
            second: '%H:%M:%S',
            minute: '%H:%M',
            hour: '%H:%M',
            day: '%e %b',
            week: '%e %b',
            month: '%b \'%y',
            year: '%Y'
        },
        min: tickPositions[0],
        max: tickPositions.slice(-1).pop(),
        tickPositions: hourTickPostions,
        labels: {
          formatter: function () {
            const tickTime = this.value;
            if (tickTime < firstReadingTime) {
              return '';
            }
            return Highcharts.dateFormat('%I:%M %p', tickTime);
          },
          step: getStep(),
        },
        title: {
            text: ''
        },
        gridLineColor: '#000000',
        gridLineWidth: 1,
    },
    yAxis: {
        title: {
            text: null,
        },
        tickInterval: 1,
        min: 3,
        max: 10,
        gridLineColor: '#000000',
        gridLineWidth: 1,
    },
    tooltip: {
        shared: false,
        followPointer: false,
        hideDelay: 0,
        zIndex: 10,
        valueSuffix: ' cm',
        formatter: function(){
            var val = this;
            return tooltipFormat(val);
        }
    },
    plotOptions: {
      series: {
        stickyTracking: false, // disables tooltip tracking near the point
        states: {
          hover: {
            enabled: true
          },
          inactive: {
            enabled: false // disables fading of other series
          },
        }
      }
    },
    legend: {
      enabled: false
    },
    series: series_data
  }

  const headDescentGraph = {
    chart: {
      marginLeft: 120,
      marginRight: 50,
      height: 300,
    },
    title: { text: '' },
    credits: { enabled: false },
    legend: { enabled: false },
    xAxis: {
      type: 'datetime',
      min: tickPositions[0],
      max: tickPositions.slice(-1).pop(),
      tickPositions: hourTickPostions,
      labels: {
        formatter: function () {
          return this.value < firstReadingTime ? '' : Highcharts.dateFormat('%I:%M %p', this.value);
        },
        step: getStep(),
      },
      title: { text: '' },
      gridLineColor: '#000000',
      gridLineWidth: 1,
    },
    yAxis: {
      title: { text: 'Descent of head (Plot O)' },
      tickInterval: 1,
      min: -6,
      max: 6,
      gridLineColor: '#000000',
      gridLineWidth: 1,
    },
    tooltip: {
      hideDelay: 0,
      shared: false,
      followPointer: false,
      formatter: function () {
        return tooltipFormat(this);
      }
    },
    plotOptions: {
      series: {
        stickyTracking: false,
        states: { hover: { enabled: true }, inactive: { enabled: false } }
      }
    },
    series: [{
      name: 'Descent of Head',
      data: headDescent,
      type: 'line',
      lineWidth: lineWidth,
      marker: {
        radius: 4,
        symbol: 'circle',
        fillColor: 'white',
        lineColor: '#000',
        lineWidth: 2
      },
      color: '#000'
    }]
  };

  const contractionGraph = {
    chart: {
      type: 'line',
      marginLeft: 120,
      marginRight: 50,
      height:250,
      styledMode: false ,
    },
    title: {
        text: '',
    },
    legend: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            millisecond: '%H:%M:%S.%L',
            second: '%H:%M:%S',
            minute: '%H:%M',
            hour: '%H:%M',
            day: '%e %b',
            week: '%e %b',
            month: '%b \'%y',
            year: '%Y'
        },
        min: tickPositions[0],
        max: tickPositions.slice(-1).pop(),
        tickPositions: hourTickPostions,
        labels: {
          formatter: function () {
            const tickTime = this.value;
            if (tickTime < firstReadingTime) {
              return '';
            }
            return Highcharts.dateFormat('%I:%M %p', tickTime);
          },
          step: getStep(),
        },
        title: {
            text: ''
        },
        gridLineColor: '#000000',
        gridLineWidth: 1,
    },
    yAxis: {
        min: 0,
        max: 5,
        tickPositions:[0,1,2,3,4,5],
        title: {
            text: 'Contractions per 10 minutes'
        },
        gridLineColor: '#000000',
        gridLineWidth: 1,
    },
    tooltip:{
        hideDelay: 0,
        shared: false,
        followPointer: false,
        formatter: function(){
            var val = this;
            return tooltipFormat(val);
        }
    },
    plotOptions: {
        series: {
            stickyTracking: false, // disables tooltip tracking near the point
            states: {
              hover: {
                enabled: true
              },
              inactive: {
                enabled: false // disables fading of other series
              },
            }
        },
    },
    series: [{
      name: 'Contractions per 10 min',
      data: contractionLine,
      lineWidth: lineWidth,
      marker: {
        radius: 4,
        symbol: 'circle'
      },
      color: '#000'
    }]
  }

  const oxytocinAndDropsGraph = {
    chart: {
      type: 'heatmap',
      marginLeft: 120,
      marginRight: 50,
      height: 250
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e %b',
        week: '%e %b',
        month: "%b '%y",
        year: '%Y'
      },
      min: tickPositions[0],
      max: tickPositions.slice(-1).pop(),
      tickPositions: hourTickPostions,
      labels: {
        formatter: function () {
          const tickTime = this.value;
          if (tickTime < firstReadingTime) {
            return '';
          }
          return Highcharts.dateFormat('%I:%M %p', tickTime);
        },
        step: getStep(),
      },
      title: {
        text: ''
      },
      gridLineColor: '#000000',
      gridLineWidth: 1,
      lineColor: 'rgba(0, 0, 0, 0.4)',
      tickColor: 'rgba(0, 0, 0, 0.4)',
    },
  
    yAxis: {
      categories: ['Drops/Per Min', 'Oxytocin<br/>(U/L)'],
      title: null,
      gridLineColor:'#000000',
      gridLineWidth: 1,
      lineColor: 'rgba(0, 0, 0, 0.4)',
      tickColor: 'rgba(0, 0, 0, 0.4)'
    },

    tooltip: {
      formatter: function () {
        // Check if point is valid and has meaningful value
        if (
          this.point &&
          typeof this.point.value !== 'undefined' &&
          this.point.value !== null &&
          this.point.value !== ''
        ) {
          return heatMapTooltipFormatTwoValue(this);
        }
        return false; // prevents tooltip from showing
      },
      hideDelay: 0,
      shared: false,
      followPointer: false,
      useHTML: true,
      backgroundColor: '#ffffff',
      borderColor: '#ccc',
      style: {
        width:`100%;`,
        color: '#000000',
        fontSize: '10px',
      }
    },
    plotOptions: {
      series: {
        stickyTracking: false, // disables tooltip tracking near the point
        states: {
          hover: {
            enabled: true
          }
        }
      }
    },
    legend: {
      enabled: false
    },
    colorAxis: {
      stops: [
        [0, 'green'],
        [0.5, 'orange'],
        [0.9, 'red']
      ],
      min: -20
    },
    series: [
      {
        name: 'Oxytocin',
        borderWidth: 1,
        background: '#000000',
        shadow: false,
        borderColor: 'rgba(0, 0, 0, 0.4)',
        borderWidth: 1,
        nullColor: '#FFFFFF',
        data: oxytocinGraphData ? oxytocinGraphData.filter(([x, y]) => y === 1):[],
        states: {
          inactive: {
            enabled: false // prevents other series from fading
          }
        },
        dataLabels: {
          enabled: true,
          useHTML: true,
          x: 50,
          style: {
            color: '#000000',
            textOutline: 'none',
            fontSize: '10px',
            whiteSpace: 'normal',
            textAlign: 'left',
          },
          formatter: function () {
            if (!this.point.value) return '';
            return `
              <div style="
                display: inline-block;
                max-width: 100px;
                min-width: 60px;
                white-space: normal;
                word-break: break-word;
                text-align: left;
                font-size: 10px;
                color: #000000;
                line-height: 1.2;
              ">
                ${this.point.value}
              </div>`;
          }
        }
      },
      {
        name: 'Drops',
        borderWidth: 1,
        background: '#000000',
        shadow: false,
        borderColor: 'rgba(0, 0, 0, 0.4)',
        borderWidth: 1,
        nullColor: '#FFFFFF',
        data: oxytocinGraphData ? oxytocinGraphData.filter(([x, y]) => y === 0):[],
        states: {
          inactive: {
            enabled: false,
          }
        },
        dataLabels: {
          enabled: true,
          useHTML: true,
          x: 50,
          style: {
            color: '#000000',
            textOutline: 'none',
            fontSize: '10px',
            whiteSpace: 'normal',
            textAlign: 'left',
          },
         
          formatter: function () {
            if (!this.point.value) return '';
            return `
              <div style="
                display: inline-block;
                max-width: 100px;
                min-width: 60px;
                white-space: normal;
                word-break: break-word;
                text-align: left;
                font-size: 10px;
                color: #000000;
                line-height: 1.2;
              ">
                ${this.point.value}
              </div>`;
          }
        }
      }
    ]
  };
  
  const drugsAndIVGraph = {
    chart: {
      type: 'heatmap',
      marginLeft: 120,
      marginRight: 50,
      height: 180,
      backgroundColor: '#FFFFFF'
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e %b',
        week: '%e %b',
        month: '%b \'%y',
        year: '%Y'
      },
      min: tickPositions[0],
      max: tickPositions[tickPositions.length - 1],
      tickPositions: hourTickPostions,
      labels: {
        formatter: function () {
          const tickTime = this.value;
          if (tickTime < firstReadingTime) {
            return '';
          }
          return Highcharts.dateFormat('%I:%M %p', tickTime);
        },
        step: getStep()
      },
      title: { 
        text: '' 
      },
      gridLineColor: 'rgba(0, 0, 0, 1)',
      gridLineWidth: 1,
      lineColor:'rgba(0, 0, 0, 1)',
      tickColor:'rgba(0, 0, 0, 1)'
    },
    yAxis: {
      categories: ['Drugs given & IV Fluids'],
      title: null,
      gridLineColor:'rgba(0, 0, 0, 1)',
      gridLineWidth: 1,
      lineColor:'rgba(0, 0, 0, 1)',
      tickColor: 'rgba(0, 0, 0, 1)'
    },
    tooltip: {
      formatter: function () {
        if (this.point && this.point.value != null && this.point.value !== '') {
          return heatMapTooltipFormat(this);
        }
        return false;
      },
      shared: false,
      followPointer: false,
      hideDelay: 0,
      backgroundColor: '#ffffff',
      borderColor: '#ccc',
      zIndex:10,
      style: {
        color: '#000000',
        fontSize: '8px',
        fontWeight: 'normal',
     
      },
      useHTML: true
    },

    plotOptions: {
      series: {
        stickyTracking: false, // disables tooltip tracking near the point
        states: {
          hover: {
            enabled: true
          }
        }
      }
    },

    legend: {
      enabled: false
    },
    colorAxis: {
      min: 0,
      minColor: '#F0F0F0',
      maxColor: '#F0F0F0'
    },
    plotOptions: {
      series: {
        borderWidth: 0.5,
        pointWidth: 100,
        borderColor: '#000000',  // updated for consistency
        dataLabels: {
          enabled: true,
          useHTML: true,
          x: 30,
          style: {
            color: '#000000',
            textOutline: 'none',
            fontSize: '8px',
            whiteSpace: 'normal',
            textAlign: 'left',
            fontWeight: 'normal'
          },
          formatter: function () {
            if (!this.point.value) return '';
  
            const titleCased = this.point.value
              .toLowerCase()
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
  
            return `
              <div style="
                display: inline-block;
                max-width: 100px;
                min-width: 60px;
                white-space: normal;
                word-break: break-word;
                text-align: left;
                font-size: 8px;
                color: #000000;
                font-weight: normal;
                line-height: 1.2;
                padding:10px,
              ">
                ${titleCased}
              </div>`;
          }
        }
      }
    },
    series: [{
      name: 'Drugs',
      data: drugsGraphData,
      dataLabels: {
        enabled: true,
        useHTML: true,
        x: 40, // remove or reduce this if needed
        style: {
          color: '#000000',
          textOutline: 'none',
          fontSize: '8px',
          whiteSpace: 'normal',
          textAlign: 'left',
          fontWeight: 'normal'
        },
        formatter: function () {
          if (!this.point.value) return '';
      
          const titleCased = this.point.value
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
      
          return `
            <div style="
              display: inline-block;
              max-width: 300px;
              min-width: 80px;
              overflow-wrap: break-word;
              white-space: normal;
              text-align: left;
              font-size:9px;
              color: #000000;
              font-weight: normal;
              line-height: 1.2;
              padding: 1px;
            ">
              ${titleCased}
            </div>`;
        }
      }
    }]
  };
  
  const pulseAndBloodPressureGraph = {
    chart: {
      marginLeft: 120,
      marginRight: 50,
      height: 440,
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: { fontWeight: 'normal', fontSize: '12px' }
    },
    credits: {
      enabled: false
    },
    title: {
      text: '',
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e %b',
        week: '%e %b',
        month: "%b '%y",
        year: '%Y'
      },
      min: tickPositions[0],
      max: tickPositions.slice(-1).pop(),
      tickPositions: hourTickPostions,
      labels: {
        formatter: function () {
          const tickTime = this.value;
          if (tickTime < firstReadingTime) {
            return '';
          }
          return Highcharts.dateFormat('%I:%M %p', tickTime);
        },
        step: getStep(),
      },
      title: {
        text: ''
      },
      gridLineColor: '#000000',
      gridLineWidth: 1,
    },
    yAxis: {
      title: {
        text: 'Pulse & Blood Pressure'
      },
      tickInterval: 1,
      gridLineColor: '#000000',
      gridLineWidth: 1,
      min: 50,
      max: 190,
      tickPositioner: function () {
        var positions = [], i = 50;
        while (i <= 190) {
          positions.push(i);
          i += 10;
        }
        return positions;
      }
    },
    tooltip: {
      hideDelay: 0,
      shared: false,
      followPointer: false,
      formatter: function () {
        var val = this;
        return tooltipFormat(val);
      }
    },
    plotOptions: {
      series: {
        stickyTracking: false, // disables tooltip tracking near the point
        states: {
          hover: {
            enabled: true
          }
        }
      }
    },
   
    series: [
      {
        name: 'Pulse (bpm)',
        data: pulse,
        type: 'line',
        lineWidth: 2,
        marker: { radius: 4, symbol: 'circle' },
        color: '#0b5f99',
        states: { inactive: { enabled: false } }
      },
      {
        name: 'Diastolic BP (mmHg)',
        data: diastolic,
        type: 'line',
        lineWidth: 2,
        marker: { radius: 4, symbol: 'circle' },
        color: '#16a34a',
        states: { inactive: { enabled: false } }
      },
      {
        name: 'Systolic (mmHg)',
        data: systolic,
        type: 'line',
        lineWidth: 2,
        marker: { radius: 4, symbol: 'circle' },
        color: '#8e2d8e',
        states: { inactive: { enabled: false } }
      }
    ],
  };

  
  const temperatureGraph = {
    chart: {
      type: 'heatmap',
      marginLeft: 120,
      marginRight: 50,
      height: 100,
      backgroundColor: '#FFFFFF'
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'datetime',
      min: tickPositions[0],
      max: tickPositions[tickPositions.length - 1],
      tickPositions: hourTickPostions,
      labels: {
        formatter: function () {
          const tickTime = this.value;
          if (tickTime < firstReadingTime) {
            return '';
          }
          return Highcharts.dateFormat('%I:%M %p', tickTime);
        },
        step: getStep()
      },
      title: {
        text: ''
      },
      gridLineColor: '#000000',
      gridLineWidth: 1,
      lineColor: '#000000',
      tickColor: '#000000'
    },
    yAxis: {
      categories: ['Temp<br/>'],
      title: null,
      gridLineColor: '#000000',
      gridLineWidth: 1,
      lineColor: '#000000',
      tickColor: '#000000',
      minorGridLineColor: '#000000',
      minorTickColor: '#000000'
    },
    tooltip: {
      hideDelay: 0,
      shared: false,
      followPointer: false,
      formatter: function () {
        if (this.point && this.point.value != null && this.point.value !== '') {
          return heatMapTooltipFormat(this);
        }
        return false;
      },
      backgroundColor: '#ffffff',
      borderColor: '#ccc',
      style: {
        color: '#000000',
        fontSize: '10px'
      },
      useHTML: true
    },
    plotOptions: {
      series: {
        stickyTracking: false, // disables tooltip tracking near the point
        states: {
          hover: {
            enabled: true
          }
        }
      }
    },
    legend: {
      enabled: false
    },
    colorAxis: {
      visible: false
    },
    series: [{
      name: 'Temperature',
      data: tempratureGraphData,
      borderColor: '#000000',
      borderWidth: 0.6,
      nullColor: '#FFFFFF',
      dataLabels: {
        enabled: true,
        useHTML: true,
        x: 40,
        style: {
          color: '#000000',
          textOutline: 'none',
          fontSize: '10px',
          whiteSpace: 'normal',
          textAlign: 'left'
        },
        formatter: function () {
          if (!this.point.value) return '';
          return `
            <div style="
              display: inline-block;
              max-width: 100px;
              min-width: 60px;
              white-space: normal;
              word-break: break-word;
              text-align: left;
              font-size: 9px;
              color: #000000;
              line-height: 1.2;
            ">
              ${this.point.value}
            </div>`;
        }
      }
    }]
  };

  const urineChart = {
    chart: {
      type: 'heatmap',
      marginLeft: 120,
      marginRight: 50,
      height: 150
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e %b',
        week: '%e %b',
        month: "%b '%y",
        year: '%Y'
      },
      min: tickPositions[0],
      max: tickPositions.slice(-1).pop(),
      tickPositions: hourTickPostions,
      labels: {
        formatter: function () {
          const tickTime = this.value;
          if (tickTime < firstReadingTime) {
            return '';
          }
          return Highcharts.dateFormat('%I:%M %p', tickTime);
        },
        step: getStep(),
      },
      title: {
        text: ''
      },
      gridLineColor: '#000000',
      gridLineWidth: 1,
    },
    yAxis: {
      categories: ['Volume', 'acetone','Protein'],
      title: {
        text: 'Urine'
      },
      gridLineColor:'#000000',
      gridLineWidth: 2,
      lineColor: 'rgba(0, 0, 0)',
      tickColor: 'rgba(0, 0, 0)'
    },
    tooltip: {
      hideDelay: 0,
      formatter: function () {
        if (this.point && this.point.value != null) {
          return heatMapTooltipFormat(this);
        }
        return false;
      },
      zIndex: 10,
      useHTML: true,
      backgroundColor: '#ffffff',
      borderColor: '#ccc',
      style: {
        width: `100%`,
        color: '#000000',
        fontSize: '10px',
      }
    },
    legend: {
      enabled: false
    },
    colorAxis: {
      stops: [
        [0, 'green'],
        [0.5, 'orange'],
        [0.9, 'red']
      ],
      min: -20
    },
    series: [
      {
        name: 'Protein',
        borderWidth: 1,
        background: '#000000',
        shadow: false,
        borderColor: '#FFFFFF',
        data: [
          [Date.UTC(2025, 4, 30, 10, 0), 0, null],
        ],
        states: {
          inactive: {
            enabled: false 
          }
        },
        dataLabels: {
          enabled: true,
          useHTML: true,
          x: 25,
          style: {
            color: '#000000',
            textOutline: 'none',
            fontSize: '10px',
            whiteSpace: 'normal',
            textAlign: 'left',
          },
          formatter: function () {
            if (!this.point.value) return '';
            return `
              <div style="
                display: inline-block;
                max-width: 100px;
                min-width: 60px;
                white-space: normal;
                word-break: break-word;
                text-align: left;
                font-size: 10px;
                color: #000000;
                line-height: 1.2;
              ">
                ${this.point.value}
              </div>`;
          }
        }
      },
      {
        name: 'acetone',
        borderWidth: 1,
        background: '#000000',
        shadow: false,
        borderColor: '#FFFFFF',
        data: [
          [Date.UTC(2025, 4, 30, 11, 0), 1, null]
        ],
        states: {
          inactive: {
            enabled: false // prevents other series from fading
          }
        },
        dataLabels: {
          enabled: true,
          useHTML: true,
          x: 25,
          style: {
            color: '#000000',
            textOutline: 'none',
            fontSize: '10px',
            whiteSpace: 'normal',
            textAlign: 'left',
          },
          formatter: function () {
            if (!this.point.value) return '';
            return `
              <div style="
                display: inline-block;
                max-width: 100px;
                min-width: 60px;
                white-space: normal;
                word-break: break-word;
                text-align: left;
                font-size: 10px;
                color: #000000;
                line-height: 1.2;
              ">
                ${this.point.value}
              </div>`;
          }
        }
      },
      {
        name: 'Volume',
        borderWidth: 1,
        background: '#000000',
        shadow: false,
        borderColor: '#FFFFFF',
        data: [
          [Date.UTC(2025, 4, 30, 12, 0), 2, null]
        ],
        states: {
          inactive: {
            enabled: false // prevents other series from fading
          }
        },
        dataLabels: {
          enabled: true,
          useHTML: true,
          x: 25,
          style: {
            color: '#000000',
            textOutline: 'none',
            fontSize: '10px',
            whiteSpace: 'normal',
            textAlign: 'left',
          },
          formatter: function () {
            if (!this.point.value) return '';
            return `
              <div style="
                display: inline-block;
                max-width: 100px;
                min-width: 60px;
                white-space: normal;
                word-break: break-word;
                text-align: left;
                font-size: 10px;
                color: #000000;
                line-height: 1.2;
              ">
                ${this.point.value}
              </div>`;
          }
        }
      }
    ]
  };
  
  return (

    <div className='partograph' id="partograph" style={{display:'flex', flexDirection:'column', gap:'2.5rem'}}>
        
        <HighchartsReact
            highcharts={Highcharts}
            options={fetalGraph}
            constructorType={'chart'}
            allowChartUpdate={true}  
        />
      
        <HighchartsReact
          highcharts={Highcharts}
          options={amnioticGraph}
          constructorType={'chart'}
          allowChartUpdate={true}  
        />
      
        <HighchartsReact
          highcharts={Highcharts}
          options={cervixAndHeadDescentGraph}
          constructorType={'chart'}
          allowChartUpdate={true}
        />

        <HighchartsReact
          highcharts={Highcharts}
          options={headDescentGraph}
          constructorType={'chart'}
          allowChartUpdate={true}
        />
      
        <HighchartsReact
          highcharts={Highcharts}
          options={contractionGraph}
          constructorType={'chart'}
          allowChartUpdate={true}  
        />
      
        <HighchartsReact
          highcharts={Highcharts}
          options={oxytocinAndDropsGraph}
          constructorType={'chart'}
          allowChartUpdate={true}  
        />
      
        <HighchartsReact
          highcharts={Highcharts}
          options={drugsAndIVGraph}
          constructorType={'chart'}
          allowChartUpdate={true}  
        />
      
        <HighchartsReact
          highcharts={Highcharts}
          options={pulseAndBloodPressureGraph}
          constructorType={'chart'}
          allowChartUpdate={true}  
        />
      
        <HighchartsReact
          highcharts={Highcharts}
          options={temperatureGraph}
          constructorType={'chart'}
          allowChartUpdate={true}  
        />

        <HighchartsReact
          highcharts={Highcharts}
          options={urineChart}
          constructorType={'chart'}
          allowChartUpdate={true}  
        />

        <div className="partograph-note" style={{ padding: '20px', fontSize: '14px', lineHeight: '1.6' }}>
          <p style={{fontSize:`1rem`, fontWeight:`bolder`}}>Note:</p>
          <div  style={{display:`flex`, gap:`3rem`, alignItems:`baseline`, justifyContent:`flex-start`}}>
            <li>
              <strong style={{fontSize:`1rem`, fontWeight:`bolder`}}>Contraction per 10 min</strong><br />
              &lt; 20 sec represented by a <span style={{ display: 'inline-block', width: '14px', height: '14px', border: '1px solid black', background: 'repeating-dot-pattern', verticalAlign: 'middle', marginLeft:'5px'}}></span><br />
              In 20–40 sec represented by a <span style={{ display: 'inline-block', width: '14px', height: '14px', border: '1px solid black', background: 'repeating-linear-gradient(45deg, black 0, black 2px, white 2px, white 4px)', verticalAlign: 'middle',marginLeft:'10px' }}></span><br />
              &gt; 40 sec represented by a <span style={{ display: 'inline-block', width: '14px', height: '14px', backgroundColor: 'black', verticalAlign: 'middle', marginLeft:'10px'}}></span>
            </li>

            <li style={{ marginTop: '10px', marginLeft:'10px'}}>
              <strong style={{fontSize:`1rem`, fontWeight:`bolder`}}>Amniotic Fluid:</strong><br />
                <span style={{marginLeft:'10px'}}>ICMB for:</span>
                <li style={{marginLeft:'20px'}}>I – Intact</li>
                <li style={{marginLeft:'20px'}}>C – Clear</li>
                <li style={{marginLeft:'20px'}}>M – Meconium</li>
                <li style={{marginLeft:'20px'}}>B – Blood-stained</li>
            </li>
          </div>
        </div>
       
    </div>

  )}


export default IntrapartumGraph

